import{createModalContext}from"../modal";export const[TransferModalProvider,useTransferModalView,useTransferModalActions]=createModalContext('Transfer');